import joi from 'joi';

import { emailSchema } from '@src/schemas/email.schema';
import { passwordSchema } from '@src/schemas/password.schema';

import { SignUpFormData } from './sign-up-form.types';

export const signUpSchema = joi.object<SignUpFormData>({
  email: emailSchema.required(),
  password: passwordSchema.required(),
  fullName: joi
    .string()
    // Latin and extended latin characters, such as accented letters, and Cyrillic characters
    .pattern(/^[\u00c0-\u01ff\u0400-\u04ffa-zA-Z',.-]{2,}(?:\s[\u00c0-\u01ff\u0400-\u04ffa-zA-Z',.-]{2,})+$/i)
    .message('validationFullName')
    .required(),
  consents: joi
    .object({
      'general-terms': joi.boolean().optional(),
      marketing: joi.boolean().optional(),
      'first-party': joi.boolean().optional(),
    })
    .optional(),
});
